"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCreditFacilityReceivables = exports.createLoanTapeEvaluators = void 0;
const calc_agent_1 = require("@finley-technologies/calc-agent");
const common_1 = require("@finley-technologies/common");
const toCSV = (tape) => {
    // we need to convert ValleyBankReceivable into a CSV string.
    const buffer = common_1.csvConversion.csvArrayToFinleyBuffer({
        csvArray: tape,
    });
    return buffer;
};
const createLoanTapeEvaluators = async (maps, calcAgentMechanics, reportingDate) => {
    const loanProductIdToLoanTapeEvalators = new Map();
    await Promise.all(Array.from(maps.loanProductToReceivables.keys()).map(async (loanProductId) => {
        const config = calcAgentMechanics.loanProducts.find((lp) => lp.loanProductId === loanProductId);
        (0, common_1.finleyAssert)(config, `Could not find loan product config for ${loanProductId}`);
        const loanTapeEvaluator = await (0, calc_agent_1.createLoanTapeEvaluator)({
            config,
            loanTapeType: 'preassignedLoanTape',
            creditFacilityId: 'valley-bank',
            // @vb - we need to pass the correct ids from caller.
            orgSlugMap: {
                valleyBank: {
                    slug: 'valleyBank',
                    id: 'valleyBank',
                },
                valleyBankBorrowers: {
                    slug: 'valleyBankBorrowers',
                    id: 'valleyBankBorrowers',
                },
            },
            loanTapeMetadataExtractor: async () => ({ reportingDate }),
            f1EngineMode: undefined, // TODO: @sachinr4 - 2Fast2Formula
        });
        loanProductIdToLoanTapeEvalators.set(loanProductId, loanTapeEvaluator);
    }));
    return loanProductIdToLoanTapeEvalators;
};
exports.createLoanTapeEvaluators = createLoanTapeEvaluators;
const createCreditFacilityReceivables = async ({ maps, calcAgentMechanics, reportingDate, progressCallback, csvParser, }) => {
    const loanProductIdToLoanTapeEvalators = await (0, exports.createLoanTapeEvaluators)(maps, calcAgentMechanics, reportingDate);
    const weights = Array.from(maps.loanProductToReceivables.keys()).map((loanProductId) => maps.loanProductToReceivables.get(loanProductId).length);
    const loanProuctCallbacks = (0, calc_agent_1.createPartialProgressCallbacks)({
        progressCallback,
        weights,
    });
    const errors = [];
    const creditFacilityReceivables = [];
    let index = 0;
    for (const [loanProductId, loanTapeEvaluator,] of loanProductIdToLoanTapeEvalators) {
        (0, common_1.finleyAssert)(loanTapeEvaluator, `Could not find loanTapeEvaluator for loanProductId: ${loanProductId}`);
        // convert to cfReceivables
        // eslint-disable-next-line no-await-in-loop
        const results = await loanTapeEvaluator.convertToCreditFacilityReceivables({
            csv: toCSV(maps.loanProductToReceivables.get(loanProductId)),
            progressCallback: loanProuctCallbacks[index], // pass the partial progress callback
            csvParser,
        });
        // eslint-disable-next-line no-plusplus
        index++;
        results.errors.forEach((error) => errors.push(error));
        results.creditFacilityReceivableWithoutFinleyId.forEach((rec) => {
            // eslint-disable-next-line camelcase
            const finley_receivable_id = rec.baseFields.finley_receivable_id;
            (0, common_1.finleyAssert)(
            // eslint-disable-next-line camelcase
            typeof finley_receivable_id === 'string', `finley_receivable_id must exist in ValleyBank CreditFacilityReceivable`);
            creditFacilityReceivables.push({
                ...rec,
                finleyReceivableId: finley_receivable_id,
                assignmentFields: null, // QA does not need to know about assignment fields
            });
        });
    }
    return { errors, creditFacilityReceivables };
};
exports.createCreditFacilityReceivables = createCreditFacilityReceivables;
//# sourceMappingURL=createLoanTapeEvaluators.js.map